import { useState, useCallback } from 'react';
import FormControlLabel from '../../../../global/Mui/FormControlLabel';
import Checkbox from '../../../../global/Mui/Checkbox';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../global/Button';
import NotAllowedDevices from '../../Components/NotAllowedDevices/NotAllowedDevices';
import IconCircled, { ICON_CIRCLE_SIZE } from '../../../../global/IconCircled';

import './BatteryAlert.scss';
import batteryWarningImage from '../../../../images/battery_sticker.jpg';

const BatteryAlert = ({
  onSubmit,
  stepTrackerProps,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const handleCheckboxChange = useCallback((event) => {
    setIsChecked(event.target.checked);
  }, []);

  const redXIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="#FF4444"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1}
        d="M12 4L4 12M4 4l8 8"
      />
    </svg>
  );

  return (
    <div className="BatteryAlert">
      <div className="BatteryAlert__container">
        <div className="BatteryAlert__container--title">
          BATTERY ALERT
        </div>
        <img className="BatteryAlert__container--image" src={batteryWarningImage} alt="Battery warning" />
        <div className="BatteryAlert__container--requirements">
          <div className="BatteryAlert__container--requirements--item">
            <div className="BatteryAlert__container--requirements--item--icon">
              <IconCircled
                icon={redXIcon}
                backgroundColor="#fff"
                borderColor="#FF4444"
                size={ICON_CIRCLE_SIZE.EXTRA_SMALL}
              />
            </div>
            <div className="BatteryAlert__container--requirements--item--text">
              No damaged batteries
            </div>
          </div>
          <div className="BatteryAlert__container--requirements--item">
            <div className="BatteryAlert__container--requirements--item--icon">
              <IconCircled
                icon={redXIcon}
                backgroundColor="#fff"
                borderColor="#FF4444"
                size={ICON_CIRCLE_SIZE.EXTRA_SMALL}
              />
            </div>
            <div className="BatteryAlert__container--requirements--item--text">
              No visible or loose batteries
            </div>
          </div>
          <div className="BatteryAlert__container--requirements--item">
            <div className="BatteryAlert__container--requirements--item--icon">
              <IconCircled
                icon={redXIcon}
                backgroundColor="#fff"
                borderColor="#FF4444"
                size={ICON_CIRCLE_SIZE.EXTRA_SMALL}
              />
            </div>
            <div className="BatteryAlert__container--requirements--item--text">
              No leaking, or swollen batteries
            </div>
          </div>
        </div>

        <div className="BatteryAlert__container--content">
          <div className="BatteryAlert__container--content--actions">
            <FormControlLabel
              label="I confirm that all items I'm shipping contain no batteries that are damaged, loose, swollen, or leaking, and accept full responsibility for their condition."
              control={(
                <Checkbox
                  checkedColor="#2649D4 !important"
                  onChange={handleCheckboxChange}
                />
              )}
            />
            <Button
              type={BUTTON_TYPE.QUATERNARY}
              size={BUTTON_SIZE.LARGE}
              onClick={onSubmit}
              disabled={!isChecked}
              trackerProps={stepTrackerProps}
            >
              CONTINUE
            </Button>
          </div>
          <div className="BatteryAlert__container--content--footer">
            <div className="BatteryAlert__container--content--footer--text">
              Find out which devices can&apos;t be shipped
            </div>
            <Button
              type={BUTTON_TYPE.LINK_QUATERNARY}
              size={BUTTON_SIZE.SMALL}
              onClick={() => setShowDialog(true)}
            >
              VIEW LIST
            </Button>
          </div>
        </div>
      </div>
      <NotAllowedDevices
        open={showDialog}
        onClose={() => setShowDialog(false)}
      />
    </div>
  );
};

export default BatteryAlert;
